import { FC } from 'react';
import * as S from './styles';

export interface AiImageLoadingBarProps {
  label: string;
  /** How long the bar takes to reach 100%. Defaults to 45 seconds. */
  durationMs?: number;
}

export const AiImageLoadingBar: FC<AiImageLoadingBarProps> = ({ label, durationMs = 45_000 }) => (
  <S.Bar role="progressbar" aria-label={label} data-testid="create-mem-ai-generating">
    <S.Fill $durationMs={durationMs} />
    <S.Label>{label}</S.Label>
  </S.Bar>
);
